import styled from 'styled-components';

export const AdjustmentProductContainer = styled.div`
    display: flex;
    margin: ${({ margin }) => (margin ? margin : '0')};
    width: 100%;
    height: 100%;
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : 'row'};
    justify-content: ${({ justifyContent }) => justifyContent};
    align-items: ${({ alignItems }) => alignItems};
`;
export const UsagePriceFont = styled.p`
    margin: ${({ margin }) => (margin ? margin : '0')};
    display: inline-block;
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '13px')};
    color: ${({ color }) => (color ? color : '#000000')};
    text-decoration: ${({ textDecoration }) =>
        textDecoration ? textDecoration : 'none'};
    letter-spacing: ${({ letterSpacing }) =>
        letterSpacing ? letterSpacing : '0px'};
    line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : '20px')};
    padding: ${({ padding }) => (padding ? padding : '0rem')};
    opacity: ${({ opacity }) => (opacity ? opacity : 1)};
`;

export const Type = styled.span`
    background: #ebebeb 0% 0% no-repeat padding-box;
    border-radius: 10px;
    display: inline;
    padding-left: 5px;
    padding-right: 5px;
    margin-left: 5px;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.1px;
    color: #140f4b;
    opacity: 1;
    font-size: 13px;
`;
